var Vendd = (function (Vendd) {
    'use strict';

    Vendd.UserWishlist = (function (UserWishlist) {

        UserWishlist.Messages = (function (Messages) {


        Messages.GetModel = function () {
            Vendd.MessageBus.VenddMessage.call(this, 'Vendd.UserWishlist.Messages.GetModel');
        };
        Messages.GetModel.className = 'Vendd.UserWishlist.Messages.GetModel';

        Messages.GetModelSuccess = function (model) {
            Vendd.MessageBus.VenddMessage.call(this, 'Vendd.UserWishlist.Messages.GetModelSuccess', model);
        };
        Messages.GetModelSuccess.className = 'Vendd.UserWishlist.Messages.GetModelSuccess';

        Messages.GetModelFailed = function (response) {
            response.data = JSON.parse(response.data);

            Vendd.MessageBus.VenddMessage.call(this, 'Vendd.UserWishlist.Messages.GetModelFailed', response);
        };
        Messages.GetModelFailed.className = 'Vendd.UserWishlist.Messages.GetModelFailed';


        Messages.DeleteWishlist = function (model) {
            Vendd.MessageBus.VenddMessage.call(this, 'Vendd.UserWishlist.Messages.DeleteWishlist', model);
        };
        Messages.DeleteWishlist.className = 'Vendd.UserWishlist.Messages.DeleteWishlist';

        Messages.DeleteWishlistFailed = function (response) {
            response.data = JSON.parse(response.data);

            Vendd.MessageBus.VenddMessage.call(this, 'Vendd.UserWishlist.Messages.DeleteWishlistFailed', response);
        };
        Messages.DeleteWishlistFailed.className = 'Vendd.UserWishlist.Messages.DeleteWishlistFailed';

        Messages.SaveWishlist = function (model) {

            var data = {
                visitorList : {
                    VisitorListId : model.VisitorListId ? model.VisitorListId : 0,
                    VisitorListTypeId : 1, //1 for wishlist
                    Code : "wishlist",
                    Name : model.Name
                }
            };

            Vendd.MessageBus.VenddMessage.call(this, 'Vendd.UserWishlist.Messages.SaveWishlist', data);
        };
        Messages.SaveWishlist.className = 'Vendd.UserWishlist.Messages.SaveWishlist';

        Messages.SaveWishlistSuccess = function () {
            Vendd.MessageBus.VenddMessage.call(this, 'Vendd.UserWishlist.Messages.SaveWishlistSuccess');
        };
        Messages.SaveWishlistSuccess.className = 'Vendd.UserWishlist.Messages.SaveWishlistSuccess';

        Messages.SaveWishlistFailed = function (response) {
            Vendd.MessageBus.VenddMessage.call(this, 'Vendd.UserWishlist.Messages.SaveWishlistFailed', response);
        };
        Messages.SaveWishlistFailed.className = 'Vendd.UserWishlist.Messages.SaveWishlistFailed';

        return Messages;

        })(UserWishlist.Messages || {});

        return UserWishlist;

    })(Vendd.UserWishlist || {});


return Vendd;

})(Vendd || {});